<template>
  <div class="main-wrap">
    <div class="area-block" v-if="logoComputed.length > 0">
      <div class="banner-title">
        <div class="title-main">
          品牌中心
          <div class="brand-title-img"></div>
        </div>
        <div class="more all-logo">
          <!-- <i style="color: #595959; font-size: 12px !important" class="iconfont icon-maijia_youjin"></i> -->
        </div>
      </div>
      <div style="lunbo-container">
        <van-swipe
        :class="logoList.length > 3 ? 'grid-logo-lunbo' : 'grid-logo-lunbo-row'"
        :autoplay="12000"
        :duration="1000"
        :show-indicators="false"
        loop
      >
        <van-swipe-item v-for="(item, i) in logoComputed" :key="i">
          <div class="grid-logo">
            <div v-for="(logo, j) in item" :key="`${i}-${j}`" class="logo-item">
              <img
                v-if="logo.pictureUrl"
                :src="logo.pictureUrl"
                class="logo-image"
                :alt="logo.brandTitle || '品牌logo'"
                @error="handleImageError"
                @load="handleImageLoad"
              />
              <div v-else class="logo-placeholder"></div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      </div>
     
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  logoList: {
    type: Array,
    default: () => [],
  },
})

const logoComputed = computed(() => {
  return chunkArray(props.logoList, 6) || []
})

const chunkArray = (array, chunkSize) => {
  if (!array) {
    return []
  }
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    let chunk = array.slice(i, i + chunkSize)
    if (chunk.length < chunkSize) {
      const emptyCount = chunkSize - chunk.length
      for (let j = 0; j < emptyCount; j++) {
        chunk.push({})
      } 
    }
    result.push(chunk)
  }
  return result
}

// 图片加载错误处理
const handleImageError = (e) => {
  console.error('图片加载失败:', e.target.src)
  // 可以设置默认图片
  // e.target.src = '/staticSeo/images/default-logo.png'
}

// 图片加载成功
const handleImageLoad = (e) => {
  // console.log('图片加载成功:', e.target.src)
}
</script>

<style scoped lang="scss">
.logo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 0; /* 允许grid项目收缩 */
  
  .logo-image {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
    display: block;
  }

  .logo-placeholder {
    width: 100%;
    height: 100%;
    min-height: 44px;
  }
}

.main-wrap {
	padding: 0 8px;
	margin-bottom: 8px;
	background: linear-gradient(180deg, #f2f4fa 0%, #f1f4fa 90%);
}


.area-block {
	border-radius: 5px;
	background: #fff;
	overflow: hidden;
}
.brand-title-img {
	width: 65px;
	height: 7px;
	top: 1.6rem;
	position: absolute;
	background-repeat: no-repeat;
	background-size: contain;
	background-image: url('/staticSeo/images/home/brandTitle.png');
	opacity: 0.8;
}

.grid-logo-lunbo {
	padding: 0 8px 8px 8px;
	height: 7.6rem !important; /* 2行的高度 */
}

.grid-logo-lunbo-row {
	height: 7.6rem !important; /* 即使只有一行也保持2行高度 */
	padding: 0 8px 8px 8px;
}

.grid-logo {
    width: calc(100% - 16px);
	display: grid !important;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(2, 1fr); /* 固定2行 */
	gap: 8px;
	height: 100%;
    margin: 0 8px;
}

.banner-title {
	display: flex;
	justify-content: space-between;
	padding: 8px 8px;
	.title-main {
		position: relative;
		font-size: 16px;
		font-weight: bold;
		line-height: 24px;
		width: 70px;
		color: #4556bb;
		padding-bottom: 2px;
	}
	.all-logo {
		font-size: 12px;
		display: flex;
		align-items: center;
		letter-spacing: 0px;
		color: #595959;
	}
}
.lunbo-container {
    display: flex;
    justify-content: center;
}
</style>
